/// <reference types="@angular/localize" />

import localeEs from '@angular/common/locales/es';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';

import { appConfig } from './app/app.config';
import { registerLocaleData } from '@angular/common';
import { LogOverride } from '@/utils/logs';

registerLocaleData(localeEs, 'es');

if (environment.production) {
  enableProdMode();
}

LogOverride.initialize();

const bootstrap = () => {
  bootstrapApplication(AppComponent, appConfig).catch((err) => console.log(err));
};

if (document.readyState === 'complete') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
}
